import api from "APP_ROOT/api";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { refreshCarts } from "MODULES/session/actions";

export function create(id) {
  return dispatch =>
    api.parts.bookmarks
      .create(id)
      .then(() => {
        dispatch(refreshCarts());
        toastr.success("Success", "Part successfully added to Bookmarks.");
      })
      .catch(err => {
        toastr.error("Error", get(err, "errors.base[0]"));
      });
}

export function destroy(id) {
  return dispatch =>
    api.parts.bookmarks.destroy(id).then(() => {
      dispatch(refreshCarts());
    });
}



// WEBPACK FOOTER //
// ./app/Nav/BookmarkedParts/actions.js